import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IpWhitelistService } from '../services/ip-whitelist.service';
import { CommonService } from '../services/common.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class IpWhitelistGuard implements CanActivate {
  constructor(
    private ipWhitelistService: IpWhitelistService,
    private router: Router,
    private commonService: CommonService,
    private translate: TranslateService
  ) {}

  canActivate(): Observable<boolean> {
    const hostname = window.location.hostname;
    const isDev = !environment.production && (
      hostname === 'localhost'
    );

    if (isDev) {
      this.commonService.showToast('Development mode: IP whitelist check bypassed', 'warning');
      return of(true);
    }

    return this.ipWhitelistService.getWhitelistStatus().pipe(
      map(isWhitelisted => {
        if (isWhitelisted) {
          return true;
        }

        this.commonService.showToast(this.translate.instant('ACCESS_DENIED.ACCESS_DENIED_MESSAGE'), 'danger');
        this.router.navigate(['/access-denied']);
        return false;
      }),
      catchError((error) => {
        console.error('Error checking whitelist:', error);
        this.commonService.showToast(this.translate.instant('ACCESS_DENIED.ERROR_CHECKING_IP_WHITELIST'), 'danger');
        this.router.navigate(['/access-denied']);
        return of(false);
      })
    );
  }
}